module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Design/Stamp-e71868a8300e726848608ae98828895d.svg";